import { baseQuery as productBaseQuery } from './ProductService'
import ProductModel from '@/models/Warehouse/WhProduct'
import helper from './helpers/ProductHelper'

const baseQuery = () => {
    return ProductModel.append('sale_prices', 'stocks', 'composition').include('sl_wholesale_discounts').where('type', 'promo').orderBy('-created_at')
}

const fetch = async () => {
    let response
    try {
        let result = await baseQuery().get()
        result.data = helper.frontendProductsArray(result.data)
        response = result
    } catch (error) {
        response = error.response
    }
    return response
}

const fetchWithModel = async () => {
    let response
    try {
        let result = await baseQuery().get()
        result.data = helper.frontendProductsArray(result.data)
        response = result
    } catch (error) {
        response = error.response
    }
    return {response: response, model: baseQuery()}
}

export default {
    fetch,
    fetchWithModel
}